import request from '@/utils/request'

/** 获取企业员工信息 */
export function GetStaffPage (params) {
  return request({
    url: 'system/staff/list',
    method: 'get',
    params,
  })
}
export function addStaff (data) {
  return request({
    url: 'system/staff',
    method: 'post',
    data,
  })
}

// 删除部门
export function delStaff (deptId) {
  return request({
    url: 'system/staff/' + deptId,
    method: 'delete',
  })
}

// 查询考勤组 列表
export function getManagementList (data) {
  return request({
    url: 'OA/clockInManagement/getManagementList',
    method: 'post',
    data: data,
  })
}
// 查询考勤组 列表
export function getManagementListNew (data) {
  return request({
    url: 'OA/clockInManagement/getManagementList/new',
    method: 'post',
    data: data,
  })
}

// 新增 考勤组
export function insertManagement (data) {
  return request({
    url: 'OA/clockInManagement/insert',
    method: 'post',
    data,
  })
}

// 修改 考勤组
export function updateManagement (data) {
  return request({
    url: 'OA/clockInManagement/update',
    method: 'post',
    data,
  })
}

// 删除 考勤组
export function deleteManagement (data) {
  return request({
    url: 'OA/clockInManagement/delete?id=' + data,
    method: 'get',
  })
}

// 获取考勤时间 列表
export function getListByManagementId (params) {
  return request({
    url: 'OA/clockInTime/getListByManagementId',
    method: 'get',
    params,
  })
}

// 保存考勤时间 列表
export function insertListByManagementId (data) {
  return request({
    url: 'OA/clockInTime/insert',
    method: 'post',
    data,
  })
}

// 获取考勤地址 列表
export function getTypeByManagementId (params) {
  return request({
    url: 'OA/clockInType/getTypeByManagementId',
    method: 'get',
    params,
  })
}

// 新增 考勤方式
export function insertClockInType (data) {
  return request({
    url: 'OA/clockInType/insert',
    method: 'post',
    data,
  })
}

// 保存 考勤人员
export function insertClockInPersonnel (data) {
  return request({
    url: 'OA/clockInPersonnel/insert',
    method: 'post',
    data,
  })
}

// 获取考勤人员 列表
export function getUserListByManagementId (params) {
  return request({
    url: 'OA/clockInPersonnel/userList',
    method: 'get',
    params,
  })
}

// 获取用户信息(判断是上班/下班 打卡)
export function getInfoByUserId (data) {
  return request({
    url: 'OA/clockInTable/getInfoByUserId',
    method: 'post',
    data,
  })
}
// 获取 上下班时间
export function getTodayInfo (data) {
  return request({
    url: 'OA/clockInTime/getTodayInfo',
    method: 'post',
    data,
  })
}

// 判断是否有数据
export function getUserInfo (data) {
  return request({
    url: 'OA/clockInTable/getUserInfo',
    method: 'post',
    data,
  })
}

// 判断 是否是外勤打卡
export function getClockInType (data) {
  return request({
    url: 'OA/clockInTable/getClockInType',
    method: 'post',
    data,
  })
}

// 打卡(正常打卡)
export function clockIn (data) {
  return request({
    url: 'OA/clockInTable/clockIn',
    method: 'post',
    data,
  })
}

// 打卡(外勤打卡)
export function clockInField (data) {
  return request({
    url: 'OA/clockInTable/clockInField',
    method: 'post',
    data,
  })
}

/** 审批 */
// 获取模板分组列表
export function GetGlobalTptGroupoPage (data) {
  return request({
    url: 'OA/approvalGroup/list',
    method: 'post',
    data,
  })
}

// 新增模板分组信息
export function insertGlobalTptGroupo (data) {
  return request({
    url: 'OA/approvalGroup/insert',
    method: 'post',
    data,
  })
}

// 修改模板分组信息
export function updateGlobalTptGroupo (data) {
  return request({
    url: 'OA/approvalGroup/update',
    method: 'post',
    data,
  })
}
// 删除模板分组
export function DeleteGlobalTptGroupo (params) {
  return request({
    url: 'OA/approvalGroup/delete',
    method: 'get',
    params,
  })
}

// 获取全局模板列表（二级目录，一级为模板分组，二级为模板信息）
export function GetGlobalTptList (data) {
  return request({
    url: 'OA/approvalFlowTemplate/list',
    method: 'post',
    data,
  })
}

// 获取全局模板列表(下拉框)
export function GetTptList (data) {
  return request({
    url: 'OA/approvalFlowTemplate/listByGroupId',
    method: 'post',
    data,
  })
}


// 获取统计 数据
export function getStatistics (data) {
  return request({
    url: 'OA/statisticsController/getStatistics',
    method: 'post',
    data,
  })
}

// 获取统计 人员列表
export function getStatisticsList (data) {
  return request({
    url: 'OA/statisticsController/getStatisticsList',
    method: 'post',
    data,
  })
}

// 获取统计 考勤打卡 日期
export function getPhoneStatisticsByDay (data) {
  return request({
    url: 'OA/statisticsController/getPhoneStatisticsByDay',
    method: 'post',
    data,
  })
}

// 获取统计 考勤打卡 列表
export function getClockInByUserId (data) {
  return request({
    url: 'OA/statisticsController/getClockInByUserId',
    method: 'post',
    data,
  })
}

// 保存 得贤 中赫考勤人员
export function zhInsertClockInPersonnel (data) {
  return request({
    url: 'OA/sysUser/addUser',
    method: 'post',
    data,
  })
}
// 删除 得贤 中赫考勤人员
export function zhInsertClockInPersonnelDelUser (data) {
  return request({
    url: 'OA/sysUser/delUser',
    method: 'post',
    data,
  })
}
// 获取统计 中赫 考勤打卡 日期
export function getZhuUlockRecord (data) {
  return request({
    url: 'OA/unlockRecord/day/month',
    method: 'post',
    data,
  })
}
// 获取统计 考勤打卡 列表  中赫
export function unlockRecordDetailDay (params) {
  return request({
    url: 'OA/unlockRecord/detail/day',
    method: 'get',
    params,
  })
}



// 获取考勤人员 列表
export function getSysUserList (params) {
  return request({
    url: 'OA/sysUser/userList',
    method: 'get',
    params,
  })
}
// 补卡申请
export function addRepairApply (data) {
  return request({
    url: 'OA/repair/apply',
    method: 'post',
    data,
  })
}
// 获取补卡申请列表
export function getRepairApplyList (params) {
  return request({
    url: 'OA/repair/apply/list',
    method: 'get',
    params,
  })
}
// 获取补卡申请列表 分页
export function getRepairApplyPage (params) {
  return request({
    url: 'OA/repair/apply/list/page',
    method: 'get',
    params,
  })
}

// 补卡申请审核
export function repairApplyExamine (data) {
  return request({
    url: 'OA/repair/apply/examine',
    method: 'post',
    data,
  })
}

// 查询用户补卡规则及剩余补卡次数
export function getRepairApplyNum (params) {
  return request({
    url: 'OA/repair/apply/rule',
    method: 'get',
    params,
  })
}


// 获取考勤时间
export function getListRuleByManagementId (params) {
  return request({
    url: 'OA/attendance/rule/list/managementId',
    method: 'get',
    params,
  })
}
// 保存考勤时间 列表
export function attendanceRuleUpdateBatch (data) {
  return request({
    url: 'OA/attendance/rule/update/batch',
    method: 'put',
    data,
  })
}
// 获取部门Id
export function clockInGetDeptById (params) {
  return request({
    url: 'OA/clockInManagement/getDeptById',
    method: 'get',
    params,
  })
}

